import { useRef } from 'react';
import {
	CalendarRange,
	RangeDatepicker as RangeDatePickerLib,
	RangeDatepickerProps as RangeDatepickerLibProps,
} from '@ui-kitten/components';

import { InputErrors } from '../../Input';
import { CommonFieldProps } from '../../commonFieldProps';

export interface RangeDatepickerProps extends RangeDatepickerLibProps, CommonFieldProps {
	autoDismiss?: boolean;
}

export const RangeDatepicker = ({
	status,
	error,
	errors,
	onSelect,
	autoDismiss = true,
	...props
}: RangeDatepickerProps) => {
	const statusColor = error ? 'danger' : (status as 'basic' | 'danger');

	const ref = useRef<RangeDatePickerLib>(null);

	const handleSelect = (range: CalendarRange<Date>) => {
		onSelect?.(range);

		if (autoDismiss && range.startDate && range.endDate) {
			ref.current?.blur();
		}
	};

	return (
		<RangeDatePickerLib
			ref={ref}
			caption={<InputErrors errors={errors} />}
			status={statusColor}
			onSelect={handleSelect}
			{...props}
		/>
	);
};
